var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareRoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 40C576 44.406 572.406 48 568 48H398.125C374 48 352.625 63.375 345 86.281L215.594 474.531C214.562 477.625 211.719 479.812 208.469 480H208C204.906 480 202.062 478.219 200.75 475.375L106 272.312C96.812 252.688 76.906 240 55.25 240H8C3.594 240 0 236.406 0 232S3.594 224 8 224H55.25C83.094 224 108.688 240.312 120.5 265.562L206.75 450.438L329.812 81.219C339.656 51.781 367.094 32 398.125 32H568C572.406 32 576 35.594 576 40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareRoot);
export default __webpack_public_path__ + "static/media/square-root.4b8b2e0bcd0887259c6a3d1f04995c78.svg";
export { ForwardRef as ReactComponent };